/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-07-11 13:48:36
 */
/**
 * @description:  contentTyp
 */
export const ContentTypeEnum = {
    // json
    JSON: "application/json;charset=UTF-8",
    // form-data qs
    FORM_URLENCODED: "application/x-www-form-urlencoded;charset=UTF-8",
    // form-data  upload
    FORM_DATA: "multipart/form-data;charset=UTF-8",
};

/**
 * @description: request method
 */
export const RequestEnum = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
};

export const ResultEnum = {
    SUCCESS: 0,
    ERROR: 1,
    TIMEOUT: 401,
    TYPE: "success",
};

/**
 * 请求header
 * @description:  contentTyp
 */
export const ConfigEnum = {
    // TOKEN
    TOKEN: "X-Access-Token",
    // TIMESTAMP
    TIMESTAMP: "X-TIMESTAMP",
    // Sign
    Sign: "X-Sign",
    SUBSYSTEM: "subsystem",
    // 租户id
    TENANT_ID: "X-Tenant-Id",
    // 版本
    VERSION: "X-Version",
    // 低代码应用ID
    X_LOW_APP_ID: "X-Low-App-ID",
};

export const GlobalRequestStatusEnum = {
    NORMAL: 0,
    REFRESHING: 1,
    INVALIDATE: 2,
};
